<template>
    <div>
        <MemberInfo :is-loading="isLoading" :button-text="$t('modify')" @submitted="modify" ref="memberInfo">
        </MemberInfo>
        <v-snackbar v-model="successSnackbar" location="bottom" color="success" :timeout="7000">
            <span class="text-body-1 font-weight-bold">
                {{ $t('memberEdit:success') }}
            </span>
            <template v-slot:actions>
                <v-btn color="white" variant="text" @click="successSnackbar = false">
                    {{ $t('close') }}
                </v-btn>
            </template>
        </v-snackbar>
    </div>
</template>

<script>

import MemberService from "@/service/MemberService";
import I18n from "@/i18n";
import MemberInfo from "../components/MemberInfo.vue";

export default {
    name: "MemberEdit",
    props: {
        isLoading: {
            type: Boolean,
            default: false
        }
    },
    components: {
        MemberInfo
    },
    data: function () {
        I18n.i18next.addResources("fr", "memberEdit", {
            title: "Vos informations",
            success: "Informations modifiés"
        });
        I18n.i18next.addResources("en", "memberEdit", {
            title: "Vos informations",
            success: "Informations modified"
        });
        return {
            successSnackbar: false
        }
    },
    methods: {
        modify: async function (member, done) {
            await MemberService.update(member);
            const updatedMember = await MemberService.getById(this.$store.state.user.id)
            await this.$store.dispatch('setUser', updatedMember)
            this.successSnackbar = true;
            done();
            this.$emit('modified');
        },
        setMember: function (member) {
            this.$refs.memberInfo.setMember(member);
        },        
        isValid: function () {
            return this.$refs.memberInfo.isValid();
        }
    }
}
</script>

<style scoped></style>
